export enum UserRole {
  Employee,
  Manager,
  Registration,
  None,
}

export default UserRole;
